<template>
  <div>
      <v-card flat class="d-flex mt-6 mb-12">
        <v-card flat tile>
          <v-card-text class="text-h6 font-weight-bold py-0 section-with-greenbar">
             合計校了本数
          </v-card-text>
          <v-card-text class="text-h3 font-weight-bold">
            {{ writerReports.length.toLocaleString() }}本
          </v-card-text>
        </v-card>
        <v-card flat tile class="mx-6">
          <v-card-text class="text-h6 font-weight-bold py-0 section-with-bluebar">
             合計支払い予定額
          </v-card-text>
          <v-card-text class="text-h3 font-weight-bold">
            {{ totalPaymentAmountForWriter().toLocaleString() }}円
          </v-card-text>
        </v-card>
      </v-card>
    <v-simple-table fixed-header class="table">
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-center">サイト名</th>
            <th class="text-center">記事ID</th>
            <th class="text-center">発注ID</th>
            <th class="text-center">記事タイトル</th>
            <th class="text-center">支払い予定額</th>
            <th class="text-center">文字単価</th>
            <th class="text-center">規定文字数</th>
            <th class="text-center">ボーナス</th>
            <th class="text-center">校了日</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(order, index) in writerReports" :key="index">
            <td class="text-center" :class="{'odd-index': index % 2 !== 0}">{{ order.site.siteKey }}</td>
            <td class="text-center" :class="{'odd-index': index % 2 !== 0}">{{ order.post.id }}</td>
            <td class="text-center" :class="{'odd-index': index % 2 !== 0}">{{ order.id }}</td>
            <td class="text-center" :class="{'odd-index': index % 2 !== 0}">
              <a
                :href="writerPostEditorUrl(order.site.initialDomainWithProtocol, order)"
                target="_blank"
              >
                {{ order.post.title }}
              </a>
            </td>
            <td class="text-center" :class="{'odd-index': index % 2 !== 0}">{{ order.paymentAmountForWriter.toLocaleString() }}円</td>
            <td class="text-center" :class="{'odd-index': index % 2 !== 0}">{{ order.charUnitPrice || 0 }}円</td>
            <td class="text-center" :class="{'odd-index': index % 2 !== 0}">{{ order.requiredWords.toLocaleString() }}文字</td>
            <td class="text-center" :class="{'odd-index': index % 2 !== 0}">{{ order.bonus || 0 }}円</td>
            <td class="text-center" :class="{'odd-index': index % 2 !== 0}">{{ order.completedAt | moment }}</td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>

<script>
import moment from 'moment'
import urlUtils from '@/mixins/url_utils'

export default {
  filters: {
    moment: function (val) {
      if (val) {
        return moment(val).format('YYYY/M/D')
      }
    }
  },
  props: {
    writerReports: {
      type: Array,
      required: true
    }
  },
  mixins: [urlUtils],
  methods: {
    totalPaymentAmountForWriter () {
      return this.writerReports.reduce((sum, order) => sum + order.paymentAmountForWriter, 0)
    }
  }
}
</script>

<style scoped lang="sass">
.section-with-greenbar
  border-left: solid #35C323 8px
  color: #000000 !important
  line-height: 1em !important
.section-with-bluebar
  border-left: solid #3656FF 8px
  color: #000000 !important
  line-height: 1em !important
.table
  border: solid #D8D8D8 1px
th
  background: #D1D1D1 !important
.odd-index
  background: #F8F8F8 !important
th, td
  vertical-align: middle
  border: solid #D8D8D8 1px
.v-data-table
  overflow-x: auto
  white-space: nowrap
</style>
